import { Dialog, DialogContent } from "@sentricmusic/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useEffect } from "react";

import { useGetMyWriters } from "@/api/queries";
import useAppStore from "@/store/appStateZustand";
import { useUIStateStore } from "@/store/uiStateStore";

import { CreateWriterModal } from "../songs/components/CreateWriterModal";

type Params = {
  id: string;
};

function WritersCreate() {
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { id }: Params = useParams({ strict: false });
  const navigate = useNavigate();
  const selectedAccount = useAppStore(s => s.selectedAccount) as string;

  // Fetch writers to refresh list after creation
  const writersQuery = useGetMyWriters({ aac: selectedAccount });

  const handleWriterCreated = () => {
    // Refetch writers list and navigate back
    void writersQuery.refetch();
    void navigate({ to: "/writers" });
  };

  const handleWriterUpdated = () => {
    // Refetch writers list and navigate back
    void writersQuery.refetch();
    void navigate({ to: "/writers" });
  };

  const handleClose = () => {
    // Navigate back to writers list
    void navigate({ to: "/writers" });
  };

  // Automatically open the dialog when this component mounts
  // This handles the /writers/create and /writers/:id routes
  useEffect(() => {
    // If user navigates directly to /writers, close any open dialogs
    if (id == null && window.location.pathname === "/writers") {
      // Already on writers page, do nothing
    }
  }, [id]);

  return (
    <div className="flex flex-wrap">
      <div className={`w-full ${isTunecore ? "bg-canvas-inverse" : "bg-layer-raised"} lg:min-h-screen-minus-header`}>
        <Dialog
          open={true}
          onOpenChange={(open) => {
            if (!open) {
              handleClose();
            }
          }}
        >
          <DialogContent className="max-w-2xl">
            <CreateWriterModal
              onWriterCreated={handleWriterCreated}
              onWriterUpdated={handleWriterUpdated}
              onClose={handleClose}
              editingWriterCode={id || null}
              availableWriters={writersQuery.data?.writers || []}
            />
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
export default WritersCreate;
